import { IPagination } from '.'
import Common from '../../services/common';
import { IPaginatedResponse } from '../../services/model';

/**
 * Funcion para facilitar el paginado utilizando un array de JavaScript
 * @param pag 
 * @param sort 
 * @param filters 
 * @param data 
 * @param customFilter 
 */
export const getDataFromArray = (pag?: IPagination, sort?: string | undefined, filters?: any, data?: any[], customFilter?: (source: any[]) => any[]) => 
  new Promise<IPaginatedResponse<any>>((resolve, reject) => {
    if (!data) return reject("Array inválido");

    const res : IPaginatedResponse<any> = { 
      success: true,
      total: data.length,
      pageIndex: pag?.pageIndex ?? 0,
      pageSize: pag?.pageSize,
      error: undefined
    }

    let source = data.map((d:any) => ({ ...d }));
    
    if (customFilter)
      source = customFilter(source);
    /* custom filter
    const verSelected = !!this.state.modal?.filterSelected.find(p => p === "si");
    const verUnSelected = !!this.state.modal?.filterSelected.find(p => p === "no");
    if (!verSelected) source = source.filter((p:any) => p.selected !== "si").slice(0);
    if (!verUnSelected) source = source.filter((p:any) => p.selected !== "no").slice(0);
    */

    // filter
    if (filters) {
      const fields = Object.getOwnPropertyNames(filters);
      for(let i = 0; i < fields.length; i++) {
        const field = fields[i];
        const value = filters[field].value.toLowerCase();
        source = source.filter((p:any) => !Object.getOwnPropertyNames(p).includes(field) || `${p[field]}`.toLowerCase().includes(value));
      }
    }

    // order
    if (sort) {
      const s = sort.split(' ');      
      source = source.sort((a : any, b : any) => (Common.object.getCascadePropValue(a, s[0]) > Common.object.getCascadePropValue(b, s[0]) ? 1 : -1) * (s[1] === "asc" ? 1 : -1));
    }

    // pagging
    if (res.pageSize) {
      const x = (res.pageIndex ?? 0) * (res.pageSize ?? 10);
      res.data = source.slice(x, x + (res.pageSize ?? 10) - 0);
    } else {
      res.data = source;
    }
    res.total = source.length;

    resolve(res);
  });

